import React from 'react'
import dayjs from 'dayjs'
import { NumberFmt, measureUnit } from 'src/utils'
import { useTheme } from 'styled-components'
import * as S from '../styles'
import { ProductStatusEnum, ReceivementProduct } from '../../../ReceivementTypes'
import { ReceivementProductWrapper } from '../../ReceivementProductWrapper'

interface Props {
  product: ReceivementProduct
}

const WrongProductTable = ({ product }: Props) => {
  const theme = useTheme()
  const batch = product.batches[0]

  return (
    <ReceivementProductWrapper status={ProductStatusEnum.WRONG}>
      <S.Table>
        <S.TableHeader
          columnInformation={[
            { columnName: 'Lote' },
            { columnName: 'Produto' },
            { columnName: 'Validade' },
            { columnName: 'Qtd. Total' },
            { columnName: 'Qtd. Avariada' },
            { columnName: 'Motivo Avaria' },
            { columnName: 'Qtd. útil' },
          ]}
          flexColumns={[
            1 / 2.5,
            3.25,
            1,
            1,
            1,
            0.75,
            1.25,
          ]}
          backgroundColor={theme.colors.gray}
        />
        <S.TableBody>
          <S.TableBodyRow key={batch.idBatch.toString()} backgroundColor={theme.colors.white}>
            <S.TableBodyCell flex={1 / 2.5} >{batch.idBatch}</S.TableBodyCell>
            <S.TableBodyCell flex={3.25}>{product.productDescription} {product.productCode && `Modelo: ${product.productCode}`}</S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              {batch.expirationDate
                ? dayjs(batch.expirationDate).format('DD/MM/YYYY')
                : '---'}
            </S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              <NumberFmt value={batch.totalQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
            </S.TableBodyCell>

            <S.TableBodyCell flex={1}>
              <NumberFmt value={product.damageQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
            </S.TableBodyCell>
            <S.TableBodyCell flex={0.75}>{batch.damageType}</S.TableBodyCell>
            <S.TableBodyCell flex={1.25}>
              <NumberFmt value={batch.totalQuantity - batch.damageQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
            </S.TableBodyCell>
          </S.TableBodyRow>
        </S.TableBody>
      </S.Table>
    </ReceivementProductWrapper>
  )
}

export { WrongProductTable }
